import PropTypes from 'prop-types'
import { ArrowUp, ArrowDown } from '@phosphor-icons/react'

const OrderArrows = ({
  upClick = () => null,
  downClick = () => null,
  disabled,
  disabledUp,
  disabledDown,
}) => (
  <div className="ctp-order-arrows">
    <button
      className="button ctp-order-arrows__button"
      disabled={disabled || disabledUp}
      onClick={upClick}
    >
      <ArrowUp size={16} />
    </button>
    <button
      className="button ctp-order-arrows__button"
      disabled={disabled || disabledDown}
      onClick={downClick}
    >
      <ArrowDown size={16} />
    </button>
  </div>
)

OrderArrows.propTypes = {
  upClick: PropTypes.func,
  downClick: PropTypes.func,
  disabled: PropTypes.bool,
  disabledUp: PropTypes.bool,
  disabledDown: PropTypes.bool,
}

export default OrderArrows
